import { html } from 'lit';
import { Receipt } from 'lucide-static';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { state } from 'lit/decorators.js';
import { pdsCustomIconElement as customElement } from '../../../decorators/pds-icon';
import { PdsIcon } from '../PdsIcon';

@customElement('pds-icon-receipt')
export class PdsIconReceipt extends PdsIcon {
  @state()
  icon = Receipt;

  render() {
    return html`${unsafeHTML(this.setIconAttributes())}`;
  }
}
